export default "__VITE_ASSET__Cm_dWlCz__"